import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

createRoot(document.getElementById("root")!).render(<App data-id="q4wby19j1" data-path="src/main.tsx" />);